module.exports = require('./lib/index')



//////////////////
// WEBPACK FOOTER
// ../~/react-hot-loader/index.js
// module id = 2088
// module chunks = 1